"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_GoogleMaps(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), /*#__PURE__*/React.createElement("title", null, "A26A54A0-CF56-4004-96E0-1DE1AAC854CE"), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M24.375,9.86076132e-32 C29,9.86076132e-32 32,3 32,7.625 L32,24.375 C32,29 29,32 24.375,32 L7.625,32 C3,32 0,29 0,24.375 L0,7.625 C0,3 3,2.3017203e-24 7.625,2.3017203e-24 L24.375,9.86076132e-32 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.6805032,22.6129882 C7.6805032,22.6129882 8.19260897,17.3457863 11.4079699,13.6975215 C14.6233308,10.0492567 14.1467294,6.51904146 14.1467294,6.51904146 C14.1467294,6.51904146 14.0601844,4.72241605 12.8127287,3.00718053 C11.8103041,1.62885962 9.81792821,0.255644064 7.16021812,0.266337162 C1.19515146,0.290337162 0.295703195,5.72898816 0.295703195,5.72898816 C0.295703195,5.72898816 -0.686430138,9.29832149 2.42796986,13.0593882 C5.5421032,16.8204548 6.38956986,19.8052548 6.60076986,22.6129882 C6.60076986,22.6129882 7.1629032,23.9887215 7.6805032,22.6129882 Z",
    id: "path-3"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-25.0%",
    y: "-10.9%",
    width: "149.9%",
    height: "130.5%",
    filterUnits: "objectBoundingBox",
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3rd-party-icons",
    transform: "translate(-79.000000, -274.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons+Indicators-/-3rd-Party-Icons-/-Google-Maps-/-App-Launcher",
    transform: "translate(79.000000, 274.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Google-Maps"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.375,9.86076132e-32 C29,9.86076132e-32 32,3 32,7.625 L32,24.375 C32,29 29,32 24.375,32 L7.625,32 C3,32 0,29 0,24.375 L0,7.625 C0,3 3,2.3017203e-24 7.625,2.3017203e-24 L24.375,9.86076132e-32 Z",
    id: "App-Icon-Shape",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Areas"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Blue",
    fill: "#4889F4",
    mask: "url(#mask-2)",
    points: "1.64106445 33.1354027 16.0262421 18.7548668 30.3981894 33.1354023"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Gray",
    fill: "#D3D3D3",
    mask: "url(#mask-2)",
    points: "18.3411094 16.4367863 32.7051373 2.05679468 32.7051373 30.8167771"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Green",
    fill: "#1EA362",
    mask: "url(#mask-2)",
    points: "-1.75040604 31.7292904 30.5947654 -1.00471225 -1.75040604 -1.00471225"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Yellow",
    fill: "#FFDE47",
    mask: "url(#mask-2)",
    points: "30.3587218 -0.759134899 33.0430456 1.7320362 2.73820006 32.0368818 0.327000294 29.6256823"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Pin",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.866667, -0.266667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    fill: "none"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-4)",
    xlinkHref: "#path-3"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#DC4B3E",
    fillRule: "evenodd",
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval-60",
    fill: "#812C28",
    fillRule: "evenodd",
    cx: 7.16052567,
    cy: 7.24886582,
    r: 2.53333333
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M6.58017133,3.96658966 C5.54305377,4.32209862 4.65932886,5.09963114 4.16709867,6.08358821 C3.99539046,6.42304194 3.87176056,6.78313811 3.79620894,7.15699593 C3.60847464,8.08361285 3.73897288,9.07215714 4.16480923,9.91620423 C4.4418318,10.4666697 4.84019484,10.9575015 5.32097782,11.3405337 C5.77657693,11.7029235 6.3054382,11.973569 6.86864112,12.1226534 C7.57836838,12.3130228 8.33388448,12.3084355 9.04819062,12.1455895 C9.69381348,11.9965051 10.3050947,11.6868682 10.792746,11.2373214 C11.3078706,10.7625449 11.6764709,10.138684 11.8710735,9.46665741 C12.0839917,8.73499702 12.111465,7.9528773 11.9786774,7.20057445 L7.97215253,7.20057445 L7.97215253,8.86573258 L10.2936475,8.86573258 C10.2043592,9.39784922 9.88841612,9.88409375 9.44197478,10.1845562 C9.16037332,10.3749255 8.83756189,10.4964866 8.50330325,10.5561204 C8.16904461,10.6134605 7.82104931,10.6203413 7.48679067,10.5538268 C7.14566369,10.4850186 6.82285227,10.342815 6.53896136,10.1432713 C6.0856517,9.82445998 5.73994584,9.35885792 5.56365875,8.83362209 C5.38279277,8.29921184 5.38050333,7.70516782 5.56365875,7.17305118 C5.69186755,6.79689975 5.90249628,6.45056521 6.1818083,6.16615804 C6.52522471,5.81294268 6.97166605,5.56064599 7.45473847,5.45743371 C7.86683816,5.37027667 8.30183229,5.38633192 8.70477421,5.50789305 C9.04819062,5.61110533 9.36413372,5.80147465 9.62284076,6.04918412 C9.88383723,5.78771301 10.1448337,5.5262419 10.4058302,5.26477079 C10.5431967,5.12486081 10.6874316,4.98953804 10.8202193,4.84504085 C10.4241457,4.47806385 9.9570994,4.18218864 9.44884311,3.99411293 C8.533066,3.65465921 7.50281676,3.64777839 6.58017133,3.96658966 L6.58017133,3.96658966 Z",
    id: "Google-Icon",
    fill: "#FFFFFF"
  })))))));
}

var _default = ic_GoogleMaps;
exports.default = _default;